import { lazy, Suspense, type ReactNode } from 'react';

import { getClientConfig } from '@/api';
import { APP_VERSION, isOlder } from '@/appVersion';
import { dataOf, useAsync } from '@/hooks';
import { IS_NATIVE } from '@/platform';

const UpdateRequired = lazy(() =>
  import('@/components/UpdateRequired').then((m) => ({ default: m.UpdateRequired })),
);

function NativeUpdateGate({ children }: { children: ReactNode }) {
  const minimum = dataOf(useAsync(getClientConfig, []))?.min_android_version;
  if (minimum && isOlder(APP_VERSION, minimum)) {
    return (
      <Suspense fallback={null}>
        <UpdateRequired />
      </Suspense>
    );
  }
  return children;
}

function Current({ children }: { children: ReactNode }) {
  return children;
}

export const UpdateGate = IS_NATIVE ? NativeUpdateGate : Current;
